import { useQuery } from 'react-query';
import backend from '../backend';

// tipagem do retorno do request
interface IResponseData {
  data: string[];
}

// tipagem do que o hook retorna
type IHorariosAgendamentoResponse = IResponseData['data'];

async function getHorariosAgendamento(
  dia: string,
  uuid: string,
): Promise<IHorariosAgendamentoResponse> {
  const response = await backend.get<IResponseData>(`/horarios-certificado`, {
    params: { dia, uuid },
  });
  return response.data.data;
}

export function useHorariosAgendamento(dia: string, uuid: string) {
  return useQuery(
    ['horarios-agendamento', dia, uuid],
    () => getHorariosAgendamento(dia, uuid),
    {
      staleTime: 1000 * 60 * 5,
      cacheTime: 1000 * 60 * 5,
      refetchOnWindowFocus: false,
    },
  );
}
